import { Chip, TextField, TextFieldProps } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { FieldInputProps } from "formik";
import * as React from "react";

type Props = TextFieldProps & {
    field: FieldInputProps<string>;
    options: string[];
    setFieldValue: (field: string, value: any) => void;
    value: string[];
};

export const CustomAutoComplete = ({ setFieldValue, field, placeholder, options, style, value, disabled }: Props) => (
    <Autocomplete
        multiple
        options={options}
        freeSolo
        value={value ?? []}
        disabled={disabled}
        onChange={(_, value) => {
            setFieldValue(field?.name, value);
        }}
        style={style}
        id="tags-outlined"
        renderTags={(value: string[], getTagProps) =>
            value.map((option: string, index: number) => (
                <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
        }
        renderInput={(params) => (
            <TextField
                {...params}
                variant="filled"
                placeholder={placeholder}
                InputProps={{
                    disableUnderline: true,
                    ...params.InputProps
                }}
                inputProps={{ ...params.inputProps, style: { padding: 0 } }}
            />
        )}
    />
);
